import { useMutation } from '@apollo/client';
import type {
  UpdateTagTypeMutation,
  UpdateTagTypeMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateTagTypeDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useUpdateTagTypeTRPC } from './useUpdateTagTypeTRPC';

export const useUpdateTagType = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation
  const [updateTagTypeGraphQL, graphqlState] = useMutation(
    UpdateTagTypeDocument,
    {
      update: (cache) => {
        evictField(cache, 'tag_type');
      },
    }
  );

  // tRPC mutation
  const trpcMutation = useUpdateTagTypeTRPC();

  const updateTagType = async (
    variables: UpdateTagTypeMutationVariables
  ): Promise<UpdateTagTypeMutation> => {
    if (trpcEnabled) {
      return trpcMutation.updateTagType(variables);
    }

    const result = await updateTagTypeGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to update tag type');
    }

    return result.data;
  };

  return {
    updateTagType,
    loading: trpcEnabled ? trpcMutation.loading : graphqlState.loading,
    error: trpcEnabled ? trpcMutation.error : graphqlState.error,
  };
};
